(function () {
  'use strict';

  angular
    .module('app.loadingbar')
    .run(loadingbarRun);
  loadingbarRun.$inject = ['$rootScope', '$timeout', 'cfpLoadingBar'];

  function loadingbarRun($rootScope, $timeout, cfpLoadingBar) {
    // Loading bar transition
    // -----------------------------------
    var thBar;
    $rootScope.$on('$stateChangeStart', function () {
      // check if bar container exists
      if ($('.wrapper > section').length) {
        thBar = $timeout(function () {
          cfpLoadingBar.start();
        }, 0);
      } // sets a latency Threshold
    });
    $rootScope.$on('$stateChangeSuccess', function (event) {
      event.targetScope.$watch('$viewContentLoaded', function () {
        $timeout.cancel(thBar);
        cfpLoadingBar.complete();
      });
    });
  }
})();
